"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortByDateString = exports.sortByString = exports.sortByKey = exports.getDisplayedData = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _get = _interopRequireDefault(require("@pcty/utils-commonjs/object/get"));

var _isNotNullOrEmpty = _interopRequireDefault(require("@pcty/utils-commonjs/value/isNotNullOrEmpty"));

var _reverse = _interopRequireDefault(require("@pcty/utils-commonjs/array/reverse"));

var _lodash = _interopRequireDefault(require("lodash.sortby"));

var getDisplayedData = function getDisplayedData(data, _ref) {
  var page = _ref.page,
      pageSize = _ref.pageSize,
      sorting = _ref.sorting;

  var _data = doSort(data, sorting);

  if (pageSize <= -1) return _data;

  var _page = page - 1; // because pages logically start with 1, but technically with 0


  return _data.slice(_page * pageSize, (_page + 1) * pageSize);
}; // Generic Sorting Functions


exports.getDisplayedData = getDisplayedData;

var sortByKey = function sortByKey(key) {
  return function (x) {
    var v = (0, _get.default)(x, key);
    return typeof v !== 'undefined' ? v : x;
  };
};

exports.sortByKey = sortByKey;

var sortByString = function sortByString(key) {
  return function (x) {
    var v = (0, _get.default)(x, key);
    return (0, _isNotNullOrEmpty.default)(v) ? v.toLowerCase() : null;
  };
};

exports.sortByString = sortByString;

var sortByDateString = function sortByDateString(key) {
  return function (x) {
    var v = (0, _get.default)(x, key);

    if (!!v) {
      var d = (0, _typeof2.default)(v) === 'object' ? v : new Date(v);
      var month = d.getMonth() >= 10 ? d.getMonth().toString() : '0' + d.getMonth().toString();
      var day = d.getDate() >= 10 ? d.getDate().toString() : '0' + d.getDate().toString();
      return d.getFullYear().toString() + month + day;
    }

    return null;
  };
}; // Private


exports.sortByDateString = sortByDateString;

var doSort = function doSort(data, sorting) {
  if (sorting.keys.length <= 0 || !sorting.direction) return data;
  var sorted = (0, _lodash.default)(data, sorting.keys);
  return sorting.direction === 'desc' ? (0, _reverse.default)(sorted) : sorted;
};